const useFormExample = () => {
    const onSubmit = (values: any) => {
        console.log('onSubmit', values)
    }

    return {
        onSubmit,
    }
}

export default useFormExample
